import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext, useRef, useState } from 'react';
import api from 'services/api';

interface IResourceFile {
  onCancel: () => void;
  videoId: string;
  currentResource?: any;
  resourceData?: any[];
  setResourceData: any;
}

export default function ResourceFile({
  onCancel,
  videoId,
  currentResource,
  resourceData,
  setResourceData
}: IResourceFile) {
  const { hideModal } = useContext(ModalContext);
  const inputRef = useRef(null as any);
  const initialFormData = {
    description: currentResource?.description || '',
    resource_type: 'file',
    file: currentResource?.file || (null as any),
    title: currentResource?.title || ''
  };
  const [formData, setFormData] = useState(initialFormData);

  const hasFormChanged = () => {
    return JSON.stringify(initialFormData) !== JSON.stringify(formData);
  };

  const handleFileChange = (event: any) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      file: event.target.files[0]
    }));
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const submitForm = new FormData();
    submitForm.append('description', formData['description']);
    submitForm.append('resource_type', formData['resource_type']);
    submitForm.append('file', formData['file']);
    submitForm.append('title', formData['title']);
    if (currentResource) {
      api.put(`api/videos/resource/${currentResource.hash_id}/`, submitForm).then((res) => {
        if (resourceData) {
          const newResourceList = resourceData.map((resource: any) => {
            if (resource.hash_id === res.data.hash_id) {
              return { ...resource, ...res.data };
            }
            return resource;
          });
          setResourceData(newResourceList);
        }
        hideModal();
      });
    } else {
      api.post(`api/videos/${videoId}/resource/`, submitForm).then((res) => {
        setResourceData((prevData: any) => [...prevData, res.data]);
        hideModal();
      });
    }
  };

  const uploadFile = () => {
    inputRef.current.click();
  };

  return (
    <div className="transparent font-lato">
      <form onSubmit={handleSubmit}>
        <div className="relative border-x border-t bg-gray-bg-dark border-gray-300  bg-white pt-9 px-7 w-screen md:w-[700px] md:min-h-[300px] rounded-t-lg">
          <div className="flex">
            <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">File details</span>
            <CloseIcon className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100" onClick={onCancel} />
          </div>
          <div className="flex">
            <div className="flex-1">
              <p className="mb-1 font-bold mt-4">Title</p>
              <input
                type="text"
                id="title"
                name="title"
                value={formData['title']}
                className="px-4 py-2 w-full mb-4 text-xl text-[#495057] border border-solid focus:text-[#495057] focus:border-[#80bdff] focus:outline-0 focus:shadow-form border-[#ced4da] rounded-md transition-shadow duration-150 ease-in-out leading-6"
                onChange={handleInputChange}
              />
              <p className="mb-1 font-bold">Description</p>
              <textarea
                className="border border-gray-300 rounded-md px-3 py-2 w-full mb-4"
                id="description"
                name="description"
                value={formData['description']}
                spellCheck="false"
                rows={5}
                onChange={handleInputChange}
              />
              <p className="mb-1 font-bold">File</p>
              <p>{formData['file'] ? (formData['file'].name ? formData['file'].name : formData['file']) : ''}</p>
              <input type="file" className="hidden" ref={inputRef} name="file" onChange={handleFileChange} />
            </div>
          </div>
        </div>
        <div className="flex text-[13px] py-6 px-7 bg-white rounded-b-lg border-x">
          <button
            className="py-2 px-6 text-black border border-tabBorder rounded-[10px] hover:bg-gray-100"
            type="button"
            onClick={uploadFile}
          >
            Upload file
          </button>
          <button
            className="py-3 px-6 text-black border border-tabBorder ml-auto rounded-[10px] hover:bg-gray-100"
            type="button"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`py-3 px-6 ml-2 rounded-[10px] ${
              hasFormChanged() ? 'bg-red-main text-white' : 'bg-gray-300 text-black'
            }`}
            type="submit"
            disabled={!hasFormChanged()}
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}
